import React from "react"
import { Link } from "gatsby"

import CommentForm from "../components/commentForm"

import * as classes from "../styles/comments.module.css"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStar as fasFaStar, faUser } from "@fortawesome/free-solid-svg-icons"
import { faStar as farFaStar } from "@fortawesome/free-regular-svg-icons"

const sortByDate = (a, b) => {
  return new Date(b.date) - new Date(a.date)
}

const Comments = (props) => {
  return (
    <aside id="comments" className="c-bottomSection">
      {props.comments.length > 0 && (
        <section>
          <h2 className="c-bottomSection__title">{props.title}の口コミ評価</h2>
          <div className={classes.comments__lead}>
            <div className="p-rating_avarage">
              <span
                className="p-rating_avarage-stars"
                style={{
                  width:
                    (props.comments.reduce((sum, i) => sum + i.rating, 0) /
                      props.comments.length) *
                      20 +
                    "%",
                }}
              />
            </div>
            <span className="p-rating_avarage-points">
              星5つ中
              {(
                props.comments.reduce((sum, i) => sum + i.rating, 0) /
                props.comments.length
              ).toFixed(1)}
              点
            </span>
            <a href="#respond">口コミを書く</a>
          </div>
          <div>
            <p>{props.comments.length}件の口コミ</p>
            <ul className={classes.commentList}>
              {props.comments.sort(sortByDate).map((node) => (
                <li className={classes.comment} key={node.id} id={node.id}>
                  <article className={classes.commentBody}>
                    <footer>
                      <div className={classes.author}>
                        <FontAwesomeIcon icon={faUser} />
                        <div>
                          <cite className={classes.fn}>{node.name}</cite>
                          <div className={classes.metadata}>
                            <a href={`#${node.id}`}>
                              <time
                                dateTime={node.date}
                                suppressHydrationWarning
                              >
                                {node.dateReadable}
                              </time>
                            </a>
                          </div>
                          {/* .comment-metadata */}
                        </div>
                      </div>
                      {/* .comment-author */}
                    </footer>
                    <div className={classes.content}>
                      {node.title && <h3>{node.title}</h3>}
                      <div className={classes.rating}>
                        {[...Array(node.rating)].map((rating, i) => (
                          <FontAwesomeIcon icon={fasFaStar} key={i} />
                        ))}
                        {[...Array(5 - node.rating)].map((rating, i) => (
                          <FontAwesomeIcon icon={farFaStar} key={i} />
                        ))}
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: node.message,
                        }}
                      />
                    </div>
                    {/* .comment-content */}
                  </article>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}
      {props.commentOpen ? (
        <div id="respond" className={classes.respond}>
          <h3 id="reply-title" className={classes.replyTitle}>
            口コミを書く
          </h3>
          <p className="small text-gray">
            品質・スタッフさんの対応など、こちらのショップをご利用になった際の感想を、口コミとしてお寄せ下さい。これから利用される方のとても役に立ちます。口コミは承認制です。投稿前に
            <Link to={`/review-guideline/`}>口コミガイドライン</Link>
            を必ずお読み下さい。
          </p>
          <CommentForm slug={props.slug} />
        </div>
      ) : (
        <div id="respond" className={classes.respond}>
          <p>コメント投稿欄は現在メンテナンス中です。</p>
        </div>
      )}
    </aside>
  )
}

export default Comments
